import { SET_BANKSTATEMENT_LINE_ITEMS, RESET_BANKSTATEMENT_LINE_ITEMS } from "../../constants/actionTypes";

const bankStatement = (state = {}, action) => {
  switch (action.type) {
    case RESET_BANKSTATEMENT_LINE_ITEMS:
      return {
        ...state,
        listItems: [],
      };
    case SET_BANKSTATEMENT_LINE_ITEMS: {
      return {
        ...state,
        listItems: [...action.listItems],
      };
    }
    default:
      return state;
  }
};

export default bankStatement;
